import { render, staticRenderFns } from "./Blindagem.vue?vue&type=template&id=05c56abb&scoped=true"
import script from "./Blindagem.vue?vue&type=script&lang=js"
export * from "./Blindagem.vue?vue&type=script&lang=js"
import style0 from "./Blindagem.vue?vue&type=style&index=0&id=05c56abb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c56abb",
  null
  
)

export default component.exports